module.exports = __webpack_public_path__ + "img/react.0b57296d.svg";